import { useReducer, MouseEvent, useEffect } from 'react'
import { Avatar, Menu, Badge } from '@mui/material'
import {
    PeopleOutline as PeopleOutlineIcon,
    Logout as LogoutIcon,
    NotificationsActive as NotificationsActiveIcon,
    Menu as MenuIcon,
    DynamicFeed as DynamicFeedIcon,
    PhoneIphone as PhoneIphoneIcon,
    Insights,
    HelpOutlineOutlined as HelpOutlineOutlinedIcon,
    MenuBookOutlined as MenuBookOutlinedIcon,
    Checklist as ChecklistIcon,
    Close as CloseIcon,
    NotificationsOff as NotificationsOffIcon,
    Balance as BalanceIcon,
} from '@mui/icons-material'
import UserForm from '../Admin/Users/UserAdmin/UserForm'
import FAQ from '../FAQ'
import UserGuidePdf from '../UserGuide'
import { getUser, editUser } from '../../apiRoutes'
import { useToastMessage } from '../../context/ToastPopUpContext'

import {
    IconButton,
    Box,
    Tooltip,
    Grid,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    ListItem,
    Typography,
} from '@mui/material'
import { useAuth } from '../../context/AuthenticationContext'
import { useSocket } from '../../context/SocketContext'
import { UniversalModal } from '../UniversalComponents'
import LegalUploader from '../LegalDocumentationUploader/LegalUploader'
import NavMenuNotificationsModal from './NavMenuNotificationsModal'
import { useVersionChecker } from '../../context/VersionCheckerContext'
import { permissionsCheck } from '../../utilities/functionTools'
import { usePermissions } from '../../context/AuthenticationContext'
import { useGlobalState } from '../../context/GlobalStateContext'

const NavMenuAvatar = ({ sx }: any) => {
    const authentication = useAuth()
    const { apiSocket } = useSocket()
    const openChangeLog = useVersionChecker()
    const { signOutApp } = authentication
    const { globalState } = useGlobalState()
    const { oupUser } = globalState
    const { userEmail, _id } = oupUser

    const defaultState = {
        anchorEl: null,
        anchorUser: null,
        username: userEmail?.toUpperCase(),
        openUser: false,
        openBoats: false,
        openLegal: false,
        userNotifications: [],
        notificationsEnabled: true,
        openNotifications: false,

        user: oupUser,
    }
    const reducer = (oldState, newState) => ({ ...oldState, ...newState })
    const [state, setState] = useReducer(reducer, defaultState)

    const {
        notifications,
        openFaq,
        openUserGuide,
        openLegal,
        notificationsEnabled,
        user,
        userNotifications,
        username,
    } = state

    const setToastMessage = useToastMessage()

    const handleClearNotifications = async () => {
        try {
            const newUserNotificationsArchived = userNotifications?.length
                ? [...userNotifications]
                : []

            await editUser({
                ...user,
                id: user._id,
                userNotifications: [],
                userNotificationsArchived: newUserNotificationsArchived,
            })
            setState({ userNotifications: [] })
        } catch (err) {
            console.error(err)
            setToastMessage(`${err}`, 'error')
        }
    }

    const handleDeleteNotification = async (deleteId: any) => {
        const newUserNotificationsArchived = userNotifications
            ?.filter((notification) => notification?._id === deleteId)
            ?.map(({ _id }: any) => ({
                _id,
            }))

        const findNotifications = userNotifications?.filter(
            (notification) => notification?._id !== deleteId
        )

        const notificationIdsMongo = findNotifications?.map(({ _id }: any) => ({
            _id,
        }))

        try {
            await editUser({
                ...user,
                id: user._id,
                userNotifications: notificationIdsMongo,
                userNotificationsArchived: newUserNotificationsArchived,
            })
            setState({ userNotifications: findNotifications })
        } catch (err) {
            console.error(err)
            setToastMessage(`${err}`, 'error')
        }
    }

    const handleOpenUserMenu = (event: MouseEvent<HTMLElement>) => {
        setState({
            anchorUser: event.currentTarget,
            anchorEl: event.currentTarget,
        })
    }

    const disableNotifications = () => {
        setState({ notificationsEnabled: !state.notificationsEnabled })
    }

    const handleCloseUserMenu = () => {
        setState({ anchorUser: defaultState.anchorUser })
    }

    const handleOpenNotifications = () => {
        setState({ openNotifications: !state.openNotifications })
    }

    const logout = () => {
        signOutApp()
    }

    const loggedIn = [
        {
            title: 'Account',
            onClick: () =>
                setState({ openUser: !state.openUser, anchorUser: null }),
            icon: <PeopleOutlineIcon />,
        },
        {
            title: 'Change Log',
            onClick: openChangeLog,
            icon: <ChecklistIcon />,
        },
        {
            title: 'FAQ',
            onClick: () => setState({ openFaq: !openFaq, anchorUser: null }),
            icon: <HelpOutlineOutlinedIcon />,
        },
        {
            title: 'User Guide',
            onClick: () =>
                setState({ openUserGuide: !openUserGuide, anchorUser: null }),
            icon: <MenuBookOutlinedIcon />,
        },
        {
            title: 'Legal Agreements',
            onClick: () =>
                setState({ openLegal: !openLegal, anchorUser: null }),
            icon: <BalanceIcon />,
        },
        { title: 'Logout', onClick: logout, icon: <LogoutIcon /> },
    ]

    const getData = async () => {
        try {
            const user = await getUser({ _id })

            if (user) {
                setState({ user, userNotifications: user.userNotifications })
            } else {
                throw new Error('No user found')
            }
        } catch (error) {
            console.error('error')
        }
    }

    useEffect(() => {
        apiSocket?.on(_id, () => {
            getData()
        })
        getData()
    }, [])

    const setModalVisbility = async (user: any, newData: any) => {
        if (user) {
            setState({ row: user })
        } else {
            setState({
                row: defaultState.user,
            })
        }
        if (newData !== undefined) {
            return getData()
        }
    }

    const handleMarkAsRead = async (id: string) => {
        const newUserNotifications = userNotifications.map((n) =>
            n._id === id ? { ...n, read: !n.read } : n
        )

        try {
            await editUser({
                ...user,
                id: user._id,
                userNotifications: newUserNotifications,
            })

            setState({ userNotifications: newUserNotifications })
        } catch (err) {
            console.error(err)
            setToastMessage(`${err}`, 'error')
        }
    }

    // useEffect(() => {
    //     if (userEmail && userEmail !== '') {
    //         setState({ username: userEmail?.toUpperCase() })
    //     }
    // }, [userEmail])

    return (
        <Grid
            container
            spacing={2}
            id="menu-grid"
            sx={{ marginRight: 5, position: 'relative', top: 9 }}
        >
            <Grid container>
                <Grid size={6}>
                    <Tooltip title="Open settings">
                        <IconButton onClick={handleOpenUserMenu}>
                            <Avatar
                                src=""
                                sx={{
                                    color: 'inherit',
                                }}
                                variant="rounded"
                            >
                                {username &&
                                    username?.length !== 0 &&
                                    username?.substring(0, 1)}
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                </Grid>
                <Grid size={6}>
                    <Tooltip title="Open Notifications Panel">
                        <Typography
                            color={'primary'}
                            align="center"
                            sx={{ margin: 2, position: 'relative', bottom: 3 }}
                        >
                            <Badge
                                badgeContent={
                                    state.notificationsEnabled
                                        ? userNotifications &&
                                          userNotifications?.length
                                        : null
                                }
                                color="primary"
                            >
                                <IconButton
                                    onClick={handleOpenNotifications}
                                    sx={{ color: 'primary' }}
                                >
                                    {state.notificationsEnabled ? (
                                        <NotificationsActiveIcon />
                                    ) : (
                                        <NotificationsOffIcon />
                                    )}
                                </IconButton>
                            </Badge>
                        </Typography>
                    </Tooltip>
                </Grid>

                <Menu
                    sx={{
                        mt: '65px',
                        display: {
                            xs: 'flex',
                            sm: 'flex',
                            md: 'flex',
                            lg: 'flex',
                        },
                    }}
                    id="menu-appbar"
                    anchorEl={state.anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={Boolean(state.anchorUser)}
                    onClose={handleCloseUserMenu}
                >
                    <List>
                        {loggedIn.map(({ title, onClick, icon }) => (
                            <ListItem
                                sx={{
                                    color: 'inherit',
                                    display: 'block',
                                }}
                                key={`${title}.button`}
                                onClick={onClick}
                            >
                                <ListItemButton>
                                    <ListItemIcon
                                        key={`${icon}.iconbutton`}
                                        children={icon}
                                        sx={{ marginRight: -3 }}
                                    />
                                    <ListItemText
                                        sx={{
                                            my: -2,
                                        }}
                                        primary={title}
                                        key={`${title}.li.button.title`}
                                    />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Menu>
                <NavMenuNotificationsModal
                    open={state.openNotifications}
                    onClose={handleOpenNotifications}
                    userNotifications={state.userNotifications}
                    onClearNotifications={handleClearNotifications}
                    handleDeleteNotification={handleDeleteNotification}
                    handleMarkAsRead={handleMarkAsRead}
                    disableNotifications={disableNotifications}
                    notificationsEnabled={state.notificationsEnabled}
                    setUserNotifications={(updated) =>
                        setState({ userNotifications: updated })
                    }
                    user={state.user}
                    setToastMessage={setToastMessage}
                />
            </Grid>

            <UniversalModal
                onClose={() => setState({ openLegal: false })}
                open={state.openLegal}
                title="Legal Agreements"
                wrapperStyle={{
                    margin: 'auto',
                    width: '90%',
                    marginTop: 5,
                }}
            >
                {state.openLegal && (
                    <LegalUploader
                        onClose={() => setState({ openLegal: false })}
                    />
                )}
            </UniversalModal>
            <UniversalModal
                onClose={() => setState({ openUser: false })}
                open={state.openUser}
                title={` User ID: ${_id}`}
                timeStamp={` Username: ${username}`}
                wrapperStyle={{
                    margin: 'auto',
                    width: '90%',
                    marginTop: 5,
                }}
            >
                <UserForm
                    row={user}
                    userAccount={true}
                    onClose={(user: any, newData?: any) =>
                        setModalVisbility(user, newData)
                    }
                    userFormPermissionCheck={false}
                />
            </UniversalModal>

            <UniversalModal
                onClose={() => setState({ openFaq: !openFaq })}
                open={openFaq}
                title="FAQ"
            >
                <FAQ />
            </UniversalModal>

            <UniversalModal
                onClose={() => setState({ openUserGuide: !openUserGuide })}
                open={openUserGuide}
                title="User Guide"
            >
                <UserGuidePdf />
            </UniversalModal>
        </Grid>
    )
}

export default NavMenuAvatar
